import FlashMessageSupportMixin from './FlashMessageSupportMixin';
import { error2text } from 'core/utils';

export default {
  mixins: [FlashMessageSupportMixin],

  data() {
    return {
      validationErrors: null,
    };
  },

  methods: {
    async alert(message) {
      alert(message);
    },

    resetErrors() {
      this.validationErrors = null;
    },

    async onError422({ statusCode, data }) {
      console.error('onError422', statusCode, data);
      if (data === undefined || data === null) {
        const message = error2text(data);
        await this.alert(message);
      } else if (typeof data === 'string') {
        console.log('data is a string');
        try {
          const json = JSON.parse(data);
          if (json) {
            console.log('json', json);
            await this.alert(this.$t('errors.422'));
            this.errors = json.message;
          }
        } catch (e) {
          //console.log('Error processing json', e);
          const message = error2text(data);
          await this.alert(message);
        }
      } else if (typeof data === 'object') {
        console.log('data is an object');
        await this.alert(this.$t('errors.422'));
        this.validationErrors = data;
      }
    },

    async onError401({ statusCode, data, noRedirect }) {
      console.log('onError401', statusCode, data);
      const message = this.$t("errors.401"); //error2text(data);
      await this.alert(message);
      if (this.$router && !noRedirect) {
        this.$router.push({
          name: "Login",
          query: { redirect: this.$route.fullPath }
        });
      }
    },

    async onError403({ statusCode, data, noRedirect }) {
      console.log('onError403', statusCode, data);
      const message = this.$t("errors.403"); //error2text(data);
      await this.alert(message);
      if (this.$router && !noRedirect) {
        this.$router.push({
          name: "Forbidden",
          query: { redirect: this.$route.fullPath }
        });
      }
    },

    async onError404({ statusCode, data, noRedirect }) {
      console.log('onError404', statusCode, data);
      const message = this.$t("errors.404"); //error2text(data);
      await this.alert(message);
      if (this.$router && !noRedirect) {
        this.$router.push({
          name: "NotFound",
          query: { redirect: this.$route.fullPath }
        });
      }
    },

    async onError500({ statusCode, data, noRedirect }) {
      console.log('onError500', statusCode, data);
      const message = this.$t("errors.500"); //error2text(data);
      await this.alert(message);
      if (this.$router && !noRedirect) {
        this.$router.push({
          name: "ServerError",
          query: { redirect: this.$route.fullPath }
        });
      }
    },

    async onAnyError(e) {
      console.error('onAnyError', e);
      const message = error2text(e.data);
      await alert(message);
    },

    async handleError(e) {
      const { statusCode, data, doNotRedirect } = e;
      const key = 'onError' + statusCode;
      if (this[key]) {
        await this[key]({ statusCode, data, doNotRedirect });
      } else {
        await this.onAnyError(e);
      }
      if (this.loading !== undefined) {
        this.loading = false;
      }
    },

    onLogout() {
      if (this.$route && this.$route.fullPath.includes('/protected')) {
        this.$router.push({
          name: "Login",
          //query: { redirect: this.$route.fullPath }
        });
      }
    }
  }
}
